import { IEdgeServers } from '../../../../core/api/dto/BuffetDishDto'
import { setEdgeServers } from '../../../../shared/lib/setEdgeServers'
import {
  useDeleteGuestTypeToFotoboxesMutation,
  useSendGuestTypeToFotoboxesMutation,
} from '../../../../core/api/GuestTypeApi'

export const useUpdateGuestTypeStations = (
  oldValue: IEdgeServers[],
  newValue: IEdgeServers[],
) => {
  const { deletedItems, addedItems } = setEdgeServers(oldValue, newValue) || {}

  const [sendGuestTypeToFotoboxes] = useSendGuestTypeToFotoboxesMutation()
  const [deleteGuestTypeToFotoboxes] = useDeleteGuestTypeToFotoboxesMutation()

  const onUpdateStation = (planMenuGuestTypesGuids: string) => {
    if (
      deletedItems?.length &&
      process.env.REACT_APP_TYPE_SERVER === 'MainServer'
    ) {
      deleteGuestTypeToFotoboxes({
        planMenuGuestTypesGuids: [planMenuGuestTypesGuids],
        edgeServersGuids: deletedItems,
      })
    }
    if (
      addedItems?.length &&
      process.env.REACT_APP_TYPE_SERVER === 'MainServer'
    ) {
      sendGuestTypeToFotoboxes({
        planMenuGuestTypesGuids: [planMenuGuestTypesGuids],
        edgeServersGuids: addedItems,
      })
    }
  }
  return { onUpdateStation }
}
